import { ComponentWithPermissions } from '../../../../../baseComponents/CreateRoutering/types'
import FormRenderer from '../../../../../forms/FormRenderer'
import { FormRender } from '../../../../../forms/FormRenderer/types'
import { valueOrDefaultValue } from '../../../../../utils/globals/valueOrDefaultValue'
import { DataProps } from '../../../../../utils/hooks/useLangData'
import useTwinTranslation from '../../../../../utils/hooks/useTwinTranslation'
import { ModifiedProductLangModelType, ProductExtendedTyShort } from '../../../types'
import ProductImages from './ProductImages'

interface DefaultMainLeftProductLayoutProps extends ComponentWithPermissions {
    basicData: ProductExtendedTyShort
    data: DataProps
    getData: () => Promise<void>
    changeValCurrentLang: (field: string, value: string) => void
    selectedLang: string
    children?: React.ReactNode
}

const DefaultMainLeftProductLayout: React.FC<DefaultMainLeftProductLayoutProps> = ({ basicData, userPermissions, getData, changeValCurrentLang, selectedLang, data,  children}) => {
    const { t } = useTwinTranslation()
    const fields: FormRender<ModifiedProductLangModelType> = [
        {
            cols: 1,
            title: t('mainInformation', 'Información principal'),
            elements: [
                {
                    label: t('name', 'Nombre'),
                    name: 'name',
                    component: 'InputWithLabelMargin',
                    lang: selectedLang,
                    value: data?.['name']?.[selectedLang] ?? '',
                    onChange: (name) => changeValCurrentLang('name', name),
                    readOnly: false
                },
                {
                    name: 'nameLangs',
                    component: 'InputHidden',
                    value: JSON.stringify(data?.name)
                },
                {
                    label: t('documentsDescription', 'Descripción para documentos'),
                    name: 'descriptionDocuments',
                    component: 'TextArea',
                    value: data?.['descriptionDocuments']?.[selectedLang] ?? '',
                    onChange: (name) => changeValCurrentLang('descriptionDocuments', name)
                },
                {
                    label: t('shortDescriptionDocuments', 'Descripción corta para documentos'),
                    name: 'shortDescriptionDocuments',
                    component: 'TextArea',
                    value: data?.['shortDescriptionDocuments']?.[selectedLang] ?? '',
                    onChange: (name) => changeValCurrentLang('shortDescriptionDocuments', name)
                },
                {
                    name: 'shortDescriptionDocumentsLangs',
                    component: 'InputHidden',
                    value: JSON.stringify(data?.shortDescriptionDocuments)
                },
            ]
        },
        {
            cols: 1,
            elements: [
                {
                    label: t('shortDescription', 'Descripción breve'),
                    name: 'shortDescription',
                    component: 'TwinEditor',
                    parentClassName: 'short_description',
                    className: 'h-100',
                    defaultValue: data?.['shortDescription']?.[selectedLang] ?? '',
                    onChange: (name) => changeValCurrentLang('shortDescription', name)
                },
                {
                    name: 'shortDescriptionLangs',
                    component: 'InputHidden',
                    value: JSON.stringify(data?.shortDescription)
                },
            ]
        },
        {
            cols: 1,
            elements: [
                {
                    label: t('largeDescription', 'Descripción larga'),
                    name: 'description',
                    component: 'TwinEditor',
                    className: 'h-200',
                    parentClassName: 'description',
                    defaultValue: data?.['description']?.[selectedLang] ?? '',
                    onChange: (name) => changeValCurrentLang('description', name)
                },
                {
                    name: 'descriptionLangs',
                    component: 'InputHidden',
                    value: JSON.stringify(data?.description)
                },
                {
                    name: 'descriptionDocumentsLangs',
                    component: 'InputHidden',
                    value: JSON.stringify(data?.descriptionDocuments)
                },
            ]
        },
    ]
    const parsedFields = valueOrDefaultValue(fields, userPermissions, basicData)
    return (
        <div className='flex w-3/4 product_container_left'>
            <div className='product_container_main flex flex-col flex-auto pb-20'>
                <ProductImages ProductId={String(basicData?.id)} {...{ getData, userPermissions }} />
                <FormRenderer sections={parsedFields} antiUnsaveTrigger={true} />
                {children}
            </div>
            <div className='vertical_separator_product'></div>
        </div>
    )
}

export default DefaultMainLeftProductLayout